export default __webpack_public_path__ + "static/media/repair-color.4e3a874f.svg";